var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('span',[_vm._t("default",null,{"bp":_vm.bp,"value":_vm.value})],2)
}
var staticRenderFns = []

export { render, staticRenderFns }